import { useQueryClient } from '@tanstack/react-query';
import useMutationApi from '../useMutationApi';
import { UpsertQuoteSheetLineItemsRequest } from './quote-sheets-types';

export function useUpdateQuoteSheetLineItems({
  quoteSheetId,
}: {
  quoteSheetId: string;
}) {
  const queryClient = useQueryClient();
  return useMutationApi<UpsertQuoteSheetLineItemsRequest>({
    endpoint: `accounts-payable/quote-sheets/${quoteSheetId}/line-items`,
    method: 'POST',
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [`accounts-payable/quote-sheets/${quoteSheetId}`],
        });
      },
    },
  });
}
